import { Model } from '../Models/model';
export class ListInterface {
  models: Model[];
  mainHeadingName: string;
  _id: string;
  _type: string;
  objectIdPropertyName = "id";
  listItemHeadingProperyName = "name";
  parentInstance: any;
  onclickListnerName: any;
  modelService: any;
  setOnclick(instance: any, name: string) {
    this.parentInstance = instance;
    this.onclickListnerName = name;
  }
  setOnArrowDown() {
  }
  onClick(model: any) {
    this.parentInstance[this.onclickListnerName](model);
  }
  onHover(model: any) {
  }
}
